import { stringField, numberField, booleanField, optionField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  code: stringField({ required: true }),
  timezone: stringField({ required: true }),
  lat: numberField({
    required: true,
    decimalScale: 9
  }),
  lon: numberField({
    required: true,
    decimalScale: 9
  }),
  port_area_id: stringField({ required: true }),
  max_sulfur: numberField({ required: true }),
  is_bunkering: booleanField({ initialValue: false }),
  size: optionField(),
  type: optionField(),
  synonymsName: {
    value: stringField()
  },
  synonymsCode: {
    value: stringField()
  },
  country: optionField()
};
